import { Link } from '@calendly/ui/components/link'
import { Link as RouterLink } from 'react-router-dom'

import { useBillingPath } from 'features/billing'

export const ContactLink = ({ children }) => {
  const contactSalesPath = useBillingPath('/contact_sales')

  return (
    <Link underline={false} as={RouterLink} to={contactSalesPath}>{children}</Link>
  )
}
